
import * as yup from 'yup';
import ValidationMessage from '../../constants/ValidationMessage';

export const HouseHoldInvitationValidation: any = yup.object().shape({
    invitee_Password: yup.string()
        .required(ValidationMessage.PASSWORD_REQUIRED)
        .trim(),

    password: yup.string()
        .required(ValidationMessage.PASSWORD_REQUIRED)
        .min(8, ValidationMessage?.PASSWORD_MIN_CHAR)
        .max(15, ValidationMessage?.PASSWORD_MAX_CHAR)
        .trim(),

    confrim_password: yup.string()
        .required('Please re-enter your password.')
        .oneOf([yup.ref('password')], 'Passwords do not match.')
        .trim(),

    agree_tnc: yup.boolean()
        .required(ValidationMessage?.ANY_REQUIRED + "check.")
        .oneOf([true], "Please read and accept the Privacy Policy & End User License Agreement."),
});

export const HouseHoldInvitationValidationPasswordOnly: any = yup.object().shape({
    password: yup.string()
        .required(ValidationMessage.PASSWORD_REQUIRED)
        .min(8, ValidationMessage?.PASSWORD_MIN_CHAR)
        .max(15, ValidationMessage?.PASSWORD_MAX_CHAR)
        .trim(),
});